<section class="is-flex gap-8">
  <app-text class="is-family-semiBold" [text]="label()"/>
</section>
<ng-content />